// Referências externas
import React, { useEffect, useState, useRef } from 'react';
import { FiX, FiAlertTriangle } from 'react-icons/fi';

// Referências internas
import { DynamicLoading } from '../../../common';

// Estilo
import './styles.css';

const permissaoUsuario = require('../../../services/permissaoUsuario');

export default function (props) {
    const mounted = useRef(false);
    const [token, setToken] = useState({});

    const [errosForm, setErrosForm] = useState({
        matricula_colaborador: false,
        id_usuario_colaborador: false,
        colaborador_ativo: false,
        nome_colaborador: false,
        nome_completo_colaborador: false,
        email_colaborador: false,
        funcao_colaborador: false,
        setor_colaborador: false,
        id_colaborador_superior_imediato: false,
        telefone1_colaborador: false,
        telefone2_colaborador: false,
        vinculo_colaborador: false,
    });

    const [dadosForm, setDadosForm] = useState({
        matricula_colaborador: '',
        id_usuario_colaborador: '',
        colaborador_ativo: '',
        nome_colaborador: '',
        nome_completo_colaborador: '',
        email_colaborador: '',
        funcao_colaborador: '',
        setor_colaborador: '',
        id_colaborador_superior_imediato: '0',
        telefone1_colaborador: '',
        telefone2_colaborador: '',
        vinculo_colaborador: '',
    });

    function editarColaborador(e) {
        e.preventDefault();

        console.log(dadosForm)
        console.log(dadosForm.telefone2_colaborador)
        let verificacao_erros = {};

        const matriculaRegex = /^[A-Za-z]{2}\d{3}$/;
        const primeiroNomeRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ]{2,}(?:[-'][A-Za-zÀ-ÖØ-öø-ÿ]+)?$/;
        const nomeCompletoRegex = /^([A-Za-zÀ-ÖØ-öø-ÿ]+(?:[-'][A-Za-zÀ-ÖØ-öø-ÿ]+)?\s+)+[A-Za-zÀ-ÖØ-öø-ÿ]+$/;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!matriculaRegex.test(dadosForm.matricula_colaborador)) { verificacao_erros.matricula_colaborador = true }
        if (dadosForm.colaborador_ativo === '') { verificacao_erros.colaborador_ativo = true }
        if (!primeiroNomeRegex.test(dadosForm.nome_colaborador)) { verificacao_erros.nome_colaborador = true }
        if (!nomeCompletoRegex.test(dadosForm.nome_completo_colaborador)) { verificacao_erros.nome_completo_colaborador = true }
        if (!emailRegex.test(dadosForm.email_colaborador)) { verificacao_erros.email_colaborador = true }
        if (dadosForm.telefone1_colaborador.length > 20) { verificacao_erros.telefone1_colaborador = true }
        if (dadosForm.telefone2_colaborador.length > 20) { verificacao_erros.telefone2_colaborador = true }
        if (dadosForm.vinculo_colaborador.length < 3) { verificacao_erros.vinculo_colaborador = true }
        if (dadosForm.funcao_colaborador.length < 3) { verificacao_erros.funcao_colaborador = true }
        if (dadosForm.setor_colaborador.length < 3) { verificacao_erros.setor_colaborador = true }

        setErrosForm(verificacao_erros);

        if(Object.keys(verificacao_erros).length === 0) {
            props.editarColaborador(dadosForm);
        }
    }

    function handleChange(e) {
        setDadosForm({
            ...dadosForm,
            [e.target.name]: e.target.value
        })
    }

    function preencherTeste(e) {
        e.preventDefault();
        setDadosForm({
            matricula_colaborador: 'TT777',
            id_usuario_colaborador: '',
            colaborador_ativo: "1",
            nome_colaborador: 'Teste',
            nome_completo_colaborador: 'Usuário Teste',
            email_colaborador: 'teste@teste.teste',
            funcao_colaborador: 'Teste',
            setor_colaborador: 'Teste',
            id_colaborador_superior_imediato: '0',
            telefone1_colaborador: '',
            telefone2_colaborador: '',
            vinculo_colaborador: 'CLT',
        })
    }

    useEffect(() => {
        if (!mounted.current) {
            setToken(JSON.parse(localStorage.getItem('sgc_br')));
            setDadosForm(props.dadosEditarColaborador);
            mounted.current = true;
        }        
    });

    return (
        <div className="modal-fundo">
            <div className="modal-form-dados-colaborador">
                <div className="modal-conteudo2">
                    <div className="modal-header">
                        <h2 className="wrapper-titulo">Editar colaborador</h2>
                        <button className="botao-fechar-modal" onClick={() => props.fecharModal()} >
                            <FiX />
                        </button>
                    </div>
                    <div >
                        <form className="modal-editar-colaborador">
                            <div className="modal-editar-colaborador-bloco1">
                                <div className="input-group-personalizado">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="matricula_colaborador" className="label-client-text">
                                        Matrícula {errosForm.matricula_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        style={{width: "70px", textAlign: "center"}}
                                        className="modal-cliente-input"
                                        type="text"
                                        id="matricula_colaborador"
                                        name="matricula_colaborador"
                                        value={dadosForm.matricula_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-personalizado">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="colaborador_ativo" className="label-client-text">
                                        Colaborador ativo {errosForm.colaborador_ativo && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="colaborador_ativo"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.colaborador_ativo}
                                    >
                                        <option value="">Selecione</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="id_usuario_colaborador" className="label-client-text">
                                        Usuário correspondente {errosForm.id_usuario_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="id_usuario_colaborador"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.id_usuario_colaborador}
                                    >
                                        <option value="">Nenhum</option>

                                        {props.listaUsuariosCorrespondentes
                                        .filter(x => !x.nome_usuario.toLowerCase().includes("revogado"))
                                        .map(x => (
                                            <option key={x.id_usuario} value={x.id_usuario}>{x.nome_usuario}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="nome_colaborador" className="label-client-text">
                                        Nome colaborador {errosForm.nome_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="nome_colaborador"
                                        name="nome_colaborador"
                                        value={dadosForm.nome_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="nome_completo_colaborador" className="label-client-text">
                                        Nome completo colaborador {errosForm.nome_completo_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="nome_completo_colaborador"
                                        name="nome_completo_colaborador"
                                        value={dadosForm.nome_completo_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="email_colaborador" className="label-client-text">
                                        E-mail usuário {errosForm.email_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="email_colaborador"
                                        name="email_colaborador"
                                        value={dadosForm.email_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="id_colaborador_superior_imediato" className="label-client-text">
                                        Superior imediato {errosForm.id_colaborador_superior_imediato && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="id_colaborador_superior_imediato"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.id_colaborador_superior_imediato}
                                    >
                                        {props.listaColaborador
                                        .map(x => (
                                            <option key={x.id_colaborador} value={x.id_colaborador}>{x.nome_completo_colaborador}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="telefone1_colaborador" className="label-client-text">
                                        Telefone 1 {errosForm.telefone1_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="telefone1_colaborador"
                                        name="telefone1_colaborador"
                                        value={dadosForm.telefone1_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="telefone2_colaborador" className="label-client-text">
                                        Telefone 2 {errosForm.telefone2_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="telefone2_colaborador"
                                        name="telefone2_colaborador"
                                        value={dadosForm.telefone2_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="vinculo_colaborador" className="label-client-text">
                                        Vínculo {errosForm.vinculo_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="vinculo_colaborador"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.vinculo_colaborador}
                                    >
                                        <option value="">Selecione</option>
                                        <option value="CLT">CLT</option>
                                        <option value="Estagiário">Estagiário</option>
                                        <option value="Agente Comercial">Agente Comercial</option>
                                        <option value="Outro">Outro</option>
                                        <option value="Sócio">Sócio</option>
                                    </select>
                                </div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="funcao_colaborador" className="label-client-text">
                                        Função {errosForm.funcao_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="funcao_colaborador"
                                        name="funcao_colaborador"
                                        value={dadosForm.funcao_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-colaborador-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="setor_colaborador" className="label-client-text">
                                        Setor {errosForm.setor_colaborador && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="setor_colaborador"
                                        name="setor_colaborador"
                                        value={dadosForm.setor_colaborador}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>

                            </div>

                            <div className="modal-cadastrar-novo-usuario-base">
                                <div className="modal-editar-informacoes-comuns-wrapper-botoes">
                                    {permissaoUsuario.verificar(60, token.tipo_usuario)? (<button onClick={(e) => preencherTeste(e)}>Preencher para teste</button>) : (<></>)}
                                    
                                    <button className="button-cancel" type="button" onClick={() => props.fecharModal()}> Cancelar </button>
                                    
                                    {props.doneEditarColaborador ? (
                                        <button className="button-submit" type="submit" onClick={(e) => editarColaborador(e)}> Salvar </button>
                                    )  :  (
                                        <button className="button-carregando" >
                                            <DynamicLoading height={"40px"} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}